
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { defineComponent, inject } from 'vue'
import TextInput from '@/components/shared/TextInput.vue'
import { MiscellaneousService } from '@/services/miscellaneous.service'
import { CreateAccountMessage } from '@/@types/messages/CreateAccountMessage'
import LockingButton from '@/components/shared/LockingButton.vue'
import DatePicker from 'vue3-datepicker'
import moment from 'moment'
import { ErrorsResponse } from '@/@types/responses/common/ErrorsResponse'
import CheckmarkSvg from '@/components/svgs/CheckmarkSvg.vue'
import CloseSvg from '@/components/svgs/CloseSvg.vue'

export default defineComponent({
  name: 'CreateAccount',
  components: {
    CheckmarkSvg,
    CloseSvg,
    DatePicker,
    LockingButton,
    TextInput
  },
  setup() {
    const miscellaneousService = inject(PROVIDER_CONSTANTS.miscellaneousService) as MiscellaneousService
    return {
      miscellaneousService
    }
  },
  data() {
    let dateOfBirthLocal: Date|undefined

    return {
      dateOfBirthLocal,
      dateOfBirthUtc: '',
      email: '',
      errorMessage: '',
      firstName: '',
      lastName: '',
      loading: false,
      password: '',
      showErrorMessage: false,
      showSuccessMessage: false
    }
  },
  computed: {
    formValid(): boolean {
      return this.dateOfBirthUtc.trim() !== '' &&
             this.email.trim() !== '' &&
             this.firstName.trim() !== '' &&
             this.lastName.trim() !== '' &&
             this.passwordHasCorrectLength &&
             this.passwordHasNonAlphanumericCharacter &&
             this.passwordHasNumber
    },
    passwordHasCorrectLength(): boolean {
      return this.password.trim().length >= 6
    },
    passwordHasNonAlphanumericCharacter(): boolean {
      return this.password.trim().length > 0 && !/^[a-zA-Z0-9]+$/.test(this.password)
    },
    passwordHasNumber(): boolean {
      return /\d/.test(this.password)
    }
  },
  methods: {
    createAccount(): void {
      if (this.loading) return

      this.showErrorMessage = false
      this.loading = true

      const createAccountMessage = new CreateAccountMessage(this.dateOfBirthUtc, this.email, this.firstName, this.lastName, this.password)
      this.miscellaneousService.createAccount(createAccountMessage).then(() => {
        this.loading = false
        this.showSuccessMessage = true
      }).catch(error => {
        const errorsResponse = error as ErrorsResponse

        this.loading = false
        this.errorMessage = errorsResponse.errors.map(e => e.message).join("\r\n")
        this.showErrorMessage = true
      })
    },
    onDateOfBirthChanged(): void {
      const element = document.getElementById('date-of-birth')
      element?.blur()

      this.dateOfBirthUtc = this.dateOfBirthLocal ? moment.utc(this.dateOfBirthLocal).format() : ''
    },
    onEnterPressed(): void {
      if (this.formValid)
        this.createAccount()
    }
  }
})
